//# sourceURL=userscript.js

// jQuery(function ($) {
//     $('.accordion').on('click', function () {
//         $(this).toggleClass('open');
//         $(' + *', this).fadeToggle('fast');
//     });
//     $('.accordion-tab').on('click', function () {
//         var w = $(window).width();
//         if (w < 841) {
//             $(this).toggleClass('open');
//             $(' + *', this).fadeToggle('fast');
//         }
//     });
//     $('.accordion-sp').on('click', function () {
//         var w = $(window).width();
//         if (w < 481) {
//             $(this).toggleClass('open');
//             $(' + *', this).fadeToggle('fast');
//         }
//     });
// });

// jQuery(function ($) {
// 	$('.accordion').on('click', function () {
// 		$(this).toggleClass('open');
// 	});

// 	$('.accordion-tab').on('click', function () {
// 		if ($(window).width() < 841) {
// 			$(this).toggleClass('open');
// 		}
// 	});

// 	$('.accordion-sp').on('click', function () {
// 		if ($(window).width() < 481) {
// 			$(this).toggleClass('open');
// 		}
// 	});
// });


jQuery(function ($) {
	$('.accordion').on('click', function () {
		if (window.matchMedia('(max-width: 480px)').matches) {
			$(this).toggleClass('open');
		}
	});
});